import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import { Row, Col, Form, Select, message, Spin, Modal, Drawer, Space, } from 'antd';
import moment from 'moment';
import { unstable_batchedUpdates as batchedUpdates } from 'react-dom';
import "moment-timezone";
import PropTypes from 'prop-types';
import { CheckCircleOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { Scrollbars } from 'react-custom-scrollbars';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory } from "react-router-dom";
import FeatherIcon from 'feather-icons-react';
import DetailsPage from './DetailsPage/Detailspage';
import AccountFields from './DetailsPage/AccountDetailsField'
import RelatedTab from './DetailsPage/RelatedTab'
import AddDealPage from './AddDeals'
import AddTaskPage from './AddTask';
import { UploadUserTag } from './GlobalComponents/UserCardCmnts'
import AccountRightData from './DetailsPage/AccountRightData'
import AccountIntePage from './DetailsPage/AccountIntePage'
import { setEditCall } from '../../../redux/CrmReduxCalls/EditNavCtrl';
import { AddUser } from '../style';
import { getAllCustomGroupByEntity, findAllCustomOptionsByDropdown, findAllCustomFieldsByGroupAndEntity } from '../../../Api/Services/CustomeUIApiService';
import { useNavigationDecrypted, useExcryptedNavigation, convertCurrency, ExchangeCurrency } from '../Filters/FilterConditions';
import { fetchDomainAvaliability, extractDomain } from "../../../Api/Services/CompanyApiService"
import { getStateData, getCityData, getCountryData, getAllUsersData } from '../../../Api/Services/CommonApiService'
import { getOwnerChange, getCompanyAccount, FetchAllAccount, createAccounts, updateAccounts, FetchAccountDetails } from '../../../Api/Services/AccountApiService'
import { FetchContactByAccount } from '../../../Api/Services/ContactApiService';
import { Main, BasicFormWrapper, VerticalFormStyleWrap } from '../../styled';
import { Button } from '../../../components/buttons/buttons';
import Heading from '../../../components/heading/heading';
import Popup from '../Popup/ACMassPopup'
import NotesPopup from '../Popup/NotesPopup'
import UpdateConnectionPopup from '../Popup/UpdateConnectionPopup';
import AllCancelPopup from '../Popup/AllCancelPopup';
import DefaultMessagePopup from '../Popup/DefaultMessagePopup';
import Approvaldialog from '../Popup/Approvaldialog'
import ComposeMail from '../Email/Compose';
import MergePage from '../Popup/MergePage'
import SharePopup from '../Popup/SharePopup'
import { CancelIcon, ChangeOwnerIcon, CloneIcon, DealIcon, DeleteIcon, EditIcon, EmailIcon, MergeIcon, NotesIcon, ReportsIcon, SaveIcon, ShareIcon, TaskIcon } from '../../../components/Icons/Icons';
import CommonFormFields from '../CustomizeUi/DynamicFieldGroup';

const { Option } = Select;

const LEAD_SPECIAL_FIELDS = {
    accountOwner: ({ users, OwnerChecking, UrlId }) => (
        <Select
            style={{ width: '100%' }}
            placeholder="Select Contact Owner"
            showSearch
            optionLabelProp="label"
            filterOption={(input, option) => {
                const el = option.children.props.children[1].props.children[0];
                if (el?.props?.children) {
                    return String(el.props.children).toLowerCase().includes(input.toLowerCase());
                }
                return false;
            }}
            onChange={UrlId !== undefined && UrlId !== null && UrlId[0] === "?ACCOUNT" ? (value) => OwnerChecking(value) : undefined}
        >
            {users}
        </Select>
    ),
    parentOrganization: ({ accountData, displayData }) => (
        <Select style={{ width: '100%' }}
            placeholder="Select Parent Account"
            showSearch optionLabelProp="label"
            optionFilterProp="children"
            filterOption={(input, option) => {
                const usernameElement = option.children.props.children[1].props.children[0];
                if (usernameElement && usernameElement.props && usernameElement.props.children) {
                    const username = String(usernameElement.props.children);
                    return username.toLowerCase().includes(input.toLowerCase());
                }
                return false;
            }
            }>
            {accountData.filter(item => item.accountTypeName === "Customer" && item.account_id !== displayData?.account_id).map((option, i) => (
                <Option value={option.account_id} key={i} label={(
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div className='Div_flex2'>
                            <div className='share_image' title={`${option.accountName} (${option.accountNumber})`} style={{ cursor: "default" }}>
                                {option.accountProfile !== null && option.accountProfile !== undefined && option.accountProfile !== "" ?
                                    < img src={option.accountProfile} alt="profile" />
                                    :
                                    <span className="image_icon AccountIcon">
                                        {option.accountName.slice(0, 1).toUpperCase()}
                                    </span>
                                }
                                <span className='div-ellipsis'>{option.accountName}</span>
                            </div>
                        </div>
                    </div>)}>
                    <div className='UserList-dropdown' title={`${option.accountName} (${option.accountNumber})`}>
                        <div>
                            {option.accountProfile !== null && option.accountProfile !== undefined && option.accountProfile !== "" ?
                                < img src={option.accountProfile} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                :
                                <span className='details_span_Tag AccountIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                    {option.accountName.slice(0, 1).toUpperCase()}
                                </span>
                            }</div>
                        <div>
                            <p style={{ fontWeight: 'bold', margin: 0 }}>{option.accountName}</p>
                            <p style={{ margin: 0 }}>{option?.accountNumber}</p>
                        </div>
                    </div>
                </Option>))}
        </Select>
    ),
    country: ({ allCountry, country, handleCountryChange }) => (
        <Select
            style={{ width: '100%' }}
            showSearch
            placeholder="Select Country"
            optionFilterProp="children"
            filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            onChange={handleCountryChange}
            value={country}
        >
            {allCountry?.map(opt => (
                <Option key={opt.countryId} value={opt.country}>{opt.country}</Option>
            ))}
        </Select>
    ),
    state: ({ allState, state, handleStateChange }) => (
        <Select
            style={{ width: '100%' }}
            showSearch
            placeholder="Select State"
            optionFilterProp="children"
            filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            onChange={handleStateChange}
            value={state}
        >
            {allState?.map(opt => (
                <Option key={opt.stateId} value={opt.state}>{opt.state}</Option>
            ))}
        </Select>
    ),
    city: ({ allCity, city, handleCityChange }) => (
        <Select
            style={{ width: '100%' }}
            showSearch
            placeholder="Select City"
            optionFilterProp="children"
            filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            onChange={handleCityChange}
            value={city}
        >
            {allCity?.map(opt => (
                <Option key={opt.cityId} value={opt.city}>{opt.city}</Option>
            ))}
        </Select>
    ),
};

const DEFAULT_DROPDOWN_FIELDS = ["parentOrganization", "leadOwner", "country", "state", "city"];
const excludedFields = ["accountName", "accountNumber", "parentOrganization", "accountOwner"];
const excludedType = ["FileUpload", "MultiFileUpload"];
const DEFAULT_DROPDOWN_DISPLAY_FIELDS = {
    "accountType": "accountTypeName",
    "industry": "industryName",
    "ownership": "ownershipName",
    "nomOfEmployees": "nomOfEmployeesName",
    "annualRevenue": "annualRevenueName",
    "rating": "ratingName",
    "customerStatus": "customerStatusName",
};

function AddNew({ UrlId, FromPage, setCratePage, GetAll, ShortCut, AccountApiCall, Callback }) {
    const prevValues = useRef({ UrlId: "", FromPage: "" });
    const ApprovalMessage = "This record creation has triggered an approval process. The record will be available only after it has been reviewed and approved."
    const AutomationMessage = "Your action has triggered a business rule. Relevant validations, updates, or automated actions have been applied based on the configured logic."
    const dispatch = useDispatch();
    const history = useHistory();
    const [form] = Form.useForm();
    const { emailapiValues, emailactiontype } = useSelector((state) => state.EmailData);
    const localData = useSelector((state) => state.localRedux);
    const ENTITY_ID = localData?.allEntity?.find((item) => item.entityKey === 'accounts')?.customEntityId
    const permission = localData.permissions;
    const ProfileData = localData.profile;
    const profile = ProfileData;
    const Role = localData.role;
    const companyProfile = localData.company;
    const defaultCurrency = localData.currency
    const ConvertRate = defaultCurrency?.exchangeRate;
    const CurencyDecimalPlace = defaultCurrency?.decimalOfCurrency;
    const [pages] = useState("Meeting")
    const [permissions] = useState(permission.entity);
    const [accountIDs, setAccountIDs] = useState()
    const [updatePopup, setUpdatePopup] = useState(false)
    const [openOwnerPopup, setOpenOwnerPopup] = useState(false)
    const [popupType, setPopupType] = useState()
    const [errorData, setErrorData] = useState([])
    const [isModalVisible1, setIsModalVisible1] = useState(false)
    const [openOwnerContent, setOpenOwnerContent] = useState()
    const [edit, setEdit] = useState(false)
    const [createPages, setCratePages] = useState()
    const [trigger, setTrigger] = useState()
    const [approveOpen, setApproveOpen] = useState(false)
    const [accountId, setAccountId] = useState()
    const [displayData, setDisplayData] = useState()
    const [users, setUsers] = useState([])
    const [country, setCountry] = useState()
    const [mergeOpen, setMergeOpen] = useState(false)
    const [allCountry, setAllCountry] = useState([])
    const [approveCondition, setApproveCondition] = useState(false)
    const [state, setState] = useState()
    const [allState, setAllState] = useState([])
    const [city, setCity] = useState()
    const [allCity, setAllCity] = useState([])
    const [accountData, setAccountData] = useState([])
    const [createPageTask, setCreatePageTask] = useState()
    const [optionsMap, setOptionsMap] = useState({});
    const [companyId, setCompanyId] = useState()
    const [uiReady, setUiReady] = useState(false)
    const [dataPermissions, setDataPermissions] = useState()
    const [action, setAction] = useState()
    const [assignOwner, setAssignOwner] = useState()
    const [drawerPage, setDrawerPage] = useState()
    const [editField, setEditField] = useState(false)
    const [notePopup, setNotePopup] = useState(false)
    const [NacTrigger, setNaCTrigger] = useState()
    const [page, setPage] = useState()
    const [mailOpen, setMailOpen] = useState(false)
    const [sharePopup, setSharePopup] = useState(false)
    const [states, setStates] = useState({
        selectedRows: [],
        selectedRowKeys: [],
    });
    const [report, setReport] = useState()
    const [taskProp, setTaskProp] = useState()
    const [allList, setAllList] = useState([])
    const [popupMessage, setPopupMessage] = useState(false)
    const [accountTypeName, setAccountTypeName] = useState()
    const [emailAttendees, setEmailAttendees] = useState([])
    const [dataForDeal, setDataForDeal] = useState()
    const [cancelConfirmOpen, setCancelConfirmOpen] = useState(false)
    const [openIntelligence, setOpenIntelligence] = useState(false);
    const loadingRef = useRef(false);
    const [doubleClick, setDoubleClick] = useState(false)
    const [deleteClick, setDelteClick] = useState(false)
    const [images, setImages] = useState({});
    const [deleteOptions, setDeleteOptions] = useState({});
    const [fileLists, setFileLists] = useState({});
    const [arrayDisplayData, setArrayDisplayData] = useState();
    const [dataDisables, setDataDisables] = useState({ isDisable: false, allow: false, id: null, profile: null });
    const [allFieldStructure, setAllFieldStructure] = useState([]);
    const [customGroups, setCustomGroups] = useState([]);
    const [customFields, setCustomFields] = useState();
    const setImage = (fieldKey, url) =>
        setImages(prev => ({ ...prev, [fieldKey]: url }));
    const setDeleteOption = (fieldKey, bool) =>
        setDeleteOptions(prev => ({ ...prev, [fieldKey]: bool }));
    const setFileList = (fieldKey, list) =>
        setFileLists(prev => ({ ...prev, [fieldKey]: list }));
    function formatDate(value, profile) {
        if (!value) return "";
        const format = profile?.dateFormate && profile?.dateFormate !== "" ? profile?.dateFormate : "YYYY-MM-DD";
        return moment(value).format(format);
    }
    function convertAndFormatDateTime(dateTime, company, profile) {
        if (!dateTime || !company?.timeZone || !profile?.timeZone) return "";
        const extractTimezoneName = (tzStr) => {
            const match = tzStr.match(/\)\s*([A-Za-z/_]+)/);
            return match ? match[1] : "";
        };
        const fromTimezone = extractTimezoneName(company?.timeZone);
        const toTimezone = extractTimezoneName(profile?.timeZone);
        if (!moment.tz.zone(fromTimezone) || !moment.tz.zone(toTimezone)) {
            console.warn("Invalid timezone provided");
            return "";
        }
        const converted = moment.tz(dateTime, fromTimezone).tz(toTimezone)
        const dateFormat = profile?.dateFormate && profile?.dateFormate !== "" ? profile.dateFormate : "YYYY-MM-DD";
        const formattedDate = converted.format(dateFormat);

        return formattedDate
    }
    const successMessage = (titles, data, type) => {
        const modal = Modal.success({
            className: "Glitter-MessagePopup",
            title: (
                <div style={{ display: 'flex', alignItems: 'center', gap: 5, justifyContent: "center" }}>
                    {type === "Approve" ? <ExclamationCircleOutlined style={{ color: '#f28e42', fontSize: 20 }} /> : <CheckCircleOutlined style={{ color: 'green', fontSize: 20 }} />}
                    <span>{titles}</span>
                </div>
            ),
            content: <p>{data}</p>,
            centered: true,
            okButtonProps: { style: { display: 'none' } },
            closable: true,
            onCancel: () => {
                modal.destroy();
                if (type === "Approve") {
                    // setTimeout(() => {
                    history.push('/Home/accounts')
                    // getData(accountId); // This runs after 2 seconds
                    // }, 1000);
                }
            }
        });
    }
    const onnavigate = () => {
        history.push("/Home/email-config")
    }
    const PageCancel = () => {
        history.push('/Home/accounts')
    }
    const scroolup = () => {
        const currentPosition = window.scrollY;
        if (currentPosition > 0) {
            const scrollStep = Math.max(1, Math.ceil(currentPosition / 20));
            window.scrollTo(0, currentPosition - scrollStep);
            requestAnimationFrame(scroolup);
        }
    }
    // Create
    const canCreate = (rolePermissions, actionRoleId) => {
        if (!Array.isArray(rolePermissions)) return false;
        const hasRolePermission = rolePermissions.includes(actionRoleId) || rolePermissions.includes("*");
        return hasRolePermission;
    };
    // Share
    // const canShare = (dataPermissions, action) => {
    //     if (!dataPermissions) return false;
    //     const normalizedDataPermissions = dataPermissions.split(",").map((p) => p.trim().toLowerCase());
    //     const hasDataPermission = normalizedDataPermissions.includes(action.toLowerCase());
    //     return hasDataPermission;
    // };
    // Update/Delete
    const hasRoleDeletePermission = (rolePermissions, actionRoleId) => {
        if (!Array.isArray(rolePermissions)) return false;
        return rolePermissions.includes(actionRoleId) || rolePermissions.includes("*");
    };
    const canUpdateDelete = (rolePermissions, dataPermissions, action, actionRoleId) => {
        if (!Array.isArray(rolePermissions) || !dataPermissions) return false;
        const normalizedDataPermissions = dataPermissions.split(",").map((p) => p.trim().toLowerCase());
        const hasRolePermission = rolePermissions.includes(actionRoleId) || rolePermissions.includes("*");
        const hasDataPermission = normalizedDataPermissions.includes(action.toLowerCase());
        return hasRolePermission && hasDataPermission;
    };
    const validateCode = (value) => {
        const allowedRegex = /^[A-Za-z0-9-]+$/;
        if (!allowedRegex.test(value)) {
            return "Only letters, numbers, and hyphens (-) are allowed"
            // return Promise.reject(new Error("Only letters, numbers, and hyphens (-) are allowed"));
        }
        if (value.length > 15) {
            return "Account number cannot exceed 15 characters"
            // return Promise.reject(new Error( "Account number cannot exceed 15 characters" ));
        }
        const getList = allList.filter(item => item.accountsId !== accountId)
        const existingCodes = getList.map(item => item.accountNumber)
        if (existingCodes.includes(value)) {
            return "This number already exists"
            // return Promise.reject(new Error("This number already exists"));
        }
        // return Promise.resolve();
        return null;
    };
    const generateUniqueCode = (Code, existingData) => {
        let newCode;
        const existingCodes = new Set(existingData.map(item => item.accountNumber));
        do {
            const randomNumber = Math.floor(100000 + Math.random() * 900000);
            newCode = `${Code}-${randomNumber}`;
        } while (existingCodes.has(newCode));
        return newCode;
    };
    const getList = async (type) => {
        try {
            const data = await getCompanyAccount()
            if (type === "Create") {
                const newCode = generateUniqueCode("AC", data);
                form.setFieldsValue({
                    accountNumber: newCode,
                })
            }
            setAllList(data)
        }
        catch (error) {
            message.error(error)
        }
    }
    async function getContactData(id) {
        try {
            const response = await FetchContactByAccount(id)
            return response
        } catch (error) {
            message.error(error);
            return []
        }
    }
    const normalizeValue = (value) => {
        if (value == null) return null;
        const trimmed = value?.trim?.();
        if (trimmed === "") return null;
        return trimmed ?? value;
    };
    const getCity = async (Address, isoCode) => {
        try {
            const response = await getCityData(isoCode)
            setAllCity(response);
            if (Address.city) {
                setCity(Address.city)
            } else { setCity(null); form.setFieldsValue({ city: null }) }
        } catch (error) {
            message.error(error)
        }
    }
    const getState = async (Address, option) => {
        try {
            const response = await getStateData(option)
            setAllState(response);
            if (Address.state) {
                setState(Address.state)
                const stateinfo = response.find(states => states.state === Address.state);
                if (stateinfo) {
                    const iso = stateinfo.stateId
                    getCity(Address, iso)
                }
            } else { setState(null); form.setFieldsValue({ state: null, city: null }) }
        } catch (error) {
            message.error(error)
        }
    }
    async function UserDetailsApi() {
        try {
            const data = await getAllUsersData()
            const options = data.filter(item => item.department === "Sales").map((option, i) => (
                <Option value={option.userId} key={i} label={(
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div className='Div_flex2'>
                            <div className='share_image' title={`${option.firstName} ${option.lastName} (${option.username})`} style={{ cursor: "default" }}>
                                {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                    < img src={option.profilePic} alt="profile" />
                                    :
                                    <span className="image_icon UserIcon">
                                        {option.firstName.slice(0, 1).toUpperCase()}
                                    </span>
                                }
                                <span className='div-ellipsis'>{`${option.firstName} ${option.lastName}`}</span>
                            </div>
                        </div>
                    </div>
                )}>
                    <div className='UserList-dropdown' title={`${option.firstName} ${option.lastName} (${option.username})`}>
                        <div>
                            {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                < img src={option.profilePic} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                :
                                <span className='details_span_Tag UserIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                    {option.firstName.slice(0, 1).toUpperCase()}
                                </span>
                            }</div>
                        <div>
                            <p style={{ fontWeight: 'bold', margin: 0 }}>{option.firstName} {option.lastName}</p>
                            <p style={{ margin: 0 }}>{option.username}</p>
                        </div>
                    </div>
                </Option>));
            setUsers(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    async function AccountApi() {
        try {
            const data = await FetchAllAccount()
            let accountInfo = data;
            if (displayData?.parentOrganization) {
                const isAlreadyIncluded = data?.some(contact => contact.accountId === displayData?.parentOrganization);
                if (!isAlreadyIncluded) {
                    accountInfo = [...accountInfo, {
                        accountNumber: displayData?.parentAccountNumber, accountProfile: displayData?.parentAccountProfile,
                        accountName: displayData?.parentAccount, account_id: displayData?.parentOrganization, accountTypeName: "Customer"
                    }];
                }
            }
            setAccountData(accountInfo)
        } catch (error) {
            message.error(error)
        }
    }
    // getting dropdonw chek this list
    // async function TypeDataApi() {
    //     try {
    //         const data = await FetchAllAccountType()
    //         let typeData;
    //         if (profile.roleName !== "Administrator") {
    //             typeData = data.filter((item) => item.accountTypeName === "Customer")
    //         } else {
    //             typeData = data
    //         }
    //         setTypeData(typeData)
    //     }
    //     catch (error) {
    //         message.error(error)
    //     }
    // }
    const onFinishFailed = () => {
        message.error("Please fill out all required fields")
    }
    const getCountry = async () => {
        try {
            const response = await getCountryData()
            setAllCountry(response)
            if (displayData.country) {
                const countryInfo = response.find(countrys => countrys.country === displayData.country);
                if (countryInfo) {
                    const iso = countryInfo.countryId
                    getState(displayData, iso)
                }
            } else {
                form.setFieldsValue({
                    country: null, state: null, city: null
                })
            }
        }
        catch (error) {
            message.error(error)
        }
    }
    const fetchCustomGroupsAndFields = async () => {
        try {
            const groups = await getAllCustomGroupByEntity(ENTITY_ID);
            const sorted = [...(groups || [])].sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0));
            const results = await Promise.all(
                sorted.map(group => findAllCustomFieldsByGroupAndEntity(ENTITY_ID, group.customFieldGroupId))
            );
            const fieldsMap = {};
            sorted.forEach((group, index) => {
                fieldsMap[group.customFieldGroupId] = [...(results[index] || [])].sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0));
            });
            const allFields = Object.values(fieldsMap).flat();
            const structure = allFields.map((field) => ({
                entityId: field.entityId,
                fieldId: field.fieldId,
                fieldKey: field.fieldKey,
                fieldType: field.fieldType,
                fieldLabel: field.fieldLabel,
                customFieldType: field.customFieldType,
                dropdownId: field.dropdownId,
                dropdownType: field.dropdownType,
                value: field.fieldType === 'MultiFileUpload' ? [] :
                    field.fieldType === "CheckBox" ? false : null,
            }));
            batchedUpdates(() => {
                setCustomGroups(sorted);
                setCustomFields(fieldsMap);
                setAllFieldStructure(structure);
            });
        } catch {
            message.error("Failed to load custom fields");
        }
    };
    async function getAccountReports(params) {
        try {
            const ValidDomain = await extractDomain(params)
            if (ValidDomain) {
                const Response = await fetchDomainAvaliability(ValidDomain)
                if (Response === "") {
                    setReport({ allow: false, data: null })
                }
                else {
                    setReport({ allow: true, data: Response })
                }
            }
        } catch (error) {
            message.error(error)
        }
    }
    async function preprocessFormValues(value, allFieldStructure) {
        const formattedValue = { ...value };
        formattedValue.customFieldValues = await Promise.all(
            (formattedValue.customFieldValues || []).map(async cf => {
                const fieldDef = allFieldStructure.find(f => f.fieldId === cf.fieldId);
                if (!fieldDef) return cf;
                let newValue;
                switch (fieldDef.fieldType) {
                    case "Multi-Dropdown":
                        newValue = cf.value ? cf.value.split(",").map(id => Number(id)) : [];
                        break;
                    case "Dropdown":
                        newValue = cf.value !== undefined && cf.value !== null ? Number(cf.value) : null;
                        break;
                    case "Number":
                    case "Percentage":
                        newValue = cf.value ? Number(cf.value) : null;
                        break;
                    case "Currency": {
                        const convertedCost = cf.value ? await ExchangeCurrency(Number(cf.value), ConvertRate) : null;
                        newValue = convertedCost ? Number(convertedCost?.toFixed(CurencyDecimalPlace)) : null;
                        break;
                    }
                    case "Date":
                        newValue = cf.value ? moment(cf.value) : null;
                        break;
                    case "CheckBox":
                        newValue = cf.value === "1" || cf.value === 1 || cf.value === true || cf.value === "true";
                        break;
                    default:
                        newValue = cf.value;
                        break;
                }
                return { ...cf, value: newValue };
            })
        );
        await Promise.all(
            allFieldStructure
                .filter(f => f.customFieldType === "Default")
                .map(async item => {
                    let val = formattedValue[item.fieldKey] ?? null;
                    switch (item.fieldType) {
                        case "Multi-Dropdown":
                            val = val ? val.split(",").map(id => Number(id)) : [];
                            break;
                        case 'MultiFileUpload':
                            val = val || [];
                            break;
                        case "Dropdown": {
                            if (DEFAULT_DROPDOWN_FIELDS.includes(item.fieldKey)) {
                                val = normalizeValue(val)
                            } else {
                                val = val !== undefined && val !== null ? Number(val) : null;
                            }
                            break;
                        }
                        case "Number":
                        case "Percentage":
                            val = val !== undefined && val !== null ? Number(val) : null;
                            break;
                        case "Currency": {
                            const convertedCost = val ? await ExchangeCurrency(Number(val), ConvertRate) : null;
                            val = convertedCost ? Number(convertedCost?.toFixed(CurencyDecimalPlace)) : null;
                            break;
                        }
                        case "Date":
                            val = val ? moment(val) : null;
                            break;
                        case "CheckBox":
                            val = val === "1" || val === 1 || val === true || val === "true";
                            break;
                        default:
                            val = normalizeValue(val);
                            break;
                    }
                    if (["mobile", "phone", "postcode"].includes(item.fieldKey)) {
                        val = val === "0" || val === 0 ? null : val;
                    }
                    formattedValue[item.fieldKey] = val;
                })
        );
        return formattedValue;
    }
    async function preprocessFormValues1(value, allFieldStructure) {
        const formattedValue = { ...value };
        formattedValue.customFieldValues = await Promise.all(
            (formattedValue.customFieldValues || []).map(async cf => {
                const fieldDef = allFieldStructure.find(f => f.fieldId === cf.fieldId);
                if (!fieldDef) return cf;
                let newValue;
                switch (fieldDef.fieldType) {
                    case "Dropdown":
                    case "Number":
                    case "Percentage":
                    case "Currency":
                        newValue = cf.value ? Number(cf.value) : null;
                        break;
                    case "Multi-Dropdown":
                    case "Date":
                        newValue = cf.value ? String(cf.value) : null;
                        break;
                    default:
                        newValue = cf.value;
                        break;
                }
                return { ...cf, value: newValue };
            })
        );
        await Promise.all(
            allFieldStructure
                .filter(f => f.customFieldType === "Default")
                .map(async item => {
                    let val = formattedValue[item.fieldKey] ?? null;
                    switch (item.fieldType) {
                        case "Dropdown": {
                            if (DEFAULT_DROPDOWN_FIELDS.includes(item.fieldKey)) {
                                val = normalizeValue(val)
                            } else {
                                val = val !== undefined && val !== null ? Number(val) : null;
                            }
                            break;
                        }
                        case 'MultiFileUpload':
                            val = val || [];
                            break;
                        case "Number":
                        case "Percentage":
                        case "Currency":
                            val = val ? Number(val) : null;
                            break;
                        case "Multi-Dropdown":
                        case "Date":
                            val = val ? String(val) : null;
                            break;
                        default:
                            val = normalizeValue(val);
                            break;
                    }
                    if (["mobile", "phone", "postcode"].includes(item.fieldKey)) {
                        val = val === "0" || val === 0 ? null : val;
                    }
                    formattedValue[item.fieldKey] = val;
                })
        );
        return formattedValue;
    }
    async function preprocessFormDisplay(value, allFieldStructure) {
        const formattedValue = { ...value };
        formattedValue.customFieldValues = await Promise.all(
            (formattedValue.customFieldValues || []).map(async cf => {
                const fieldDef = allFieldStructure.find(f => f.fieldId === cf.fieldId);
                if (!fieldDef) return cf;
                let newValue;
                switch (fieldDef.fieldType) {
                    case "Multi-Dropdown":
                        newValue = cf.option;
                        break;
                    case "Dropdown":
                        newValue = cf.option;
                        break;
                    case "Number":
                        newValue = cf.value ? Number(cf.value) : null;
                        break;
                    case "Percentage":
                        newValue = cf.value ? `% ${Number(cf.value)}` : null;
                        break;
                    case "Currency": {
                        const convertedCost = cf.value ? await ExchangeCurrency(Number(cf.value), ConvertRate) : null;
                        newValue = convertedCost ? `${defaultCurrency?.symbol} ${Number(convertedCost?.toFixed(CurencyDecimalPlace))?.toLocaleString()}` : null;
                        break;
                    }
                    case "Date":
                        newValue = cf.value ? formatDate(cf.value, profile) : null;
                        break;
                    case "CheckBox":
                        newValue = (cf.value === "1" || cf.value === 1 || cf.value === true || cf.value === "true") ? "Yes" : "No";
                        break;
                    default:
                        newValue = cf.value;
                        break;
                }
                return { ...cf, value: newValue };
            })
        );
        await Promise.all(
            allFieldStructure
                .filter(f => f.customFieldType === "Default")
                .map(async item => {
                    let val = formattedValue[item.fieldKey] ?? null;
                    switch (item.fieldType) {
                        // case "Multi-Dropdown":
                        //     val = val ? val.split(",").map(id => Number(id)) : [];
                        //     break;
                        case 'MultiFileUpload':
                            val = val || [];
                            break;
                        case "Dropdown": {
                            if (DEFAULT_DROPDOWN_DISPLAY_FIELDS[item.fieldKey]) {
                                const displayKey = DEFAULT_DROPDOWN_DISPLAY_FIELDS[item.fieldKey];
                                val = displayKey
                                    ? normalizeValue(formattedValue[displayKey])
                                    : normalizeValue(val);
                            } else {
                                val = val !== undefined && val !== null ? normalizeValue(val) : null;
                            }
                            break;
                        }
                        case "Number":
                            val = val !== undefined && val !== null ? Number(val) : null;
                            break;
                        case "Percentage":
                            val = val !== undefined && val !== null ? `% ${Number(val)}` : null;
                            break;
                        case "Currency": {
                            const convertedCost = val ? await ExchangeCurrency(Number(val), ConvertRate) : null;
                            val = convertedCost ? `${defaultCurrency?.symbol} ${Number(convertedCost?.toFixed(CurencyDecimalPlace))?.toLocaleString()}` : null;
                            break;
                        }
                        case "Date":
                            val = val ? formatDate(val, profile) : null;
                            break;
                        case "CheckBox":
                            val = (val === "1" || val === 1 || val === true || val === "true") ? "Yes" : "No";
                            break;
                        default:
                            val = normalizeValue(val);
                            break;
                    }
                    if (["mobile", "phone", "postcode"].includes(item.fieldKey)) {
                        val = val === "0" || val === 0 ? null : val;
                    }
                    formattedValue[item.fieldKey] = val;
                })
        );
        return formattedValue;
    }
    const setData = async (value) => {
        if (value !== undefined) {
            const formattedValue = await preprocessFormValues(value, allFieldStructure);
            const formattedValue1 = await preprocessFormValues1(value, allFieldStructure);
            const formatteddisplayValue = await preprocessFormDisplay(value, allFieldStructure);
            const formValues = allFieldStructure.reduce((acc, item) => {
                const fieldKeys = item.fieldKey;
                let fieldValue;

                if (item.customFieldType === "Custom") {
                    const cf = formattedValue?.customFieldValues?.find(cf => cf.fieldId === item.fieldId);
                    fieldValue = cf ? cf.value ?? null : null;
                } else {
                    fieldValue = formattedValue[fieldKeys];
                }
                acc[fieldKeys] =
                    item.fieldType === "Multi-Dropdown"
                        ? fieldValue || []
                        : normalizeValue(fieldValue) ?? null;

                return acc;
            }, {});
            const updatedFieldStructure = allFieldStructure.map(item => {
                const fieldKeys = item.fieldKey;
                let fieldValue;
                if (item.customFieldType === "Custom") {
                    const cf = formattedValue1?.customFieldValues?.find(cf => cf.fieldId === item.fieldId);
                    fieldValue = cf ? cf.value ?? null : null;
                } else {
                    fieldValue = formattedValue1[fieldKeys];
                }
                // if (item.fieldType === "Date" && fieldValue) {
                //     fieldValue = moment(fieldValue).format("YYYY-MM-DD");
                // }
                return {
                    ...item,
                    value: fieldValue
                    // type === "Edit"
                    //     ? (item.fieldType === "Multi-Dropdown"
                    //         ? fieldValue ? fieldValue.join(",") : []
                    //         : normalizeValue(fieldValue) ?? null)
                    //     : (item.fieldType === "Multi-Dropdown"
                    //         ? []
                    //         : null)
                };
            });
            if (drawerPage !== "CloneLead") {
                if (value.approved_for !== "None") {
                    setApproveOpen(true)
                    setApproveCondition(true)
                }
                else {
                    setApproveOpen(false)
                    setApproveCondition(false)
                }
            }
            setAllFieldStructure(updatedFieldStructure)
            setAssignOwner(formattedValue.accountOwner)
            form.setFieldsValue(formValues);
            if (drawerPage !== "CloneLead") {
                form.setFieldsValue({
                    accountNumber: formattedValue.accountNumber,
                })
            }
            if (formattedValue.accountTypeName === "Customer") {
                setAccountTypeName(formattedValue.accountTypeName)
                form.setFieldsValue({ customerStatus: formattedValue.customerStatus })
            }
            else {
                form.setFieldsValue({ customerStatus: null })
            }
            if (formattedValue?.website) {
                getAccountReports(formattedValue?.website)
            } else {
                setReport({ allow: false, data: null })
            }
            setImage('accountProfile', formattedValue.accountProfile ?? null);
            setDeleteOption('accountProfile', !!(formattedValue.accountProfile && formattedValue.accountProfile !== ''));
            setFileList('accountFiles', formattedValue.accountFiles || []);
            setAccountId(formattedValue.account_id)
            setCompanyId(formattedValue.company_id)
            setStates({
                ...states,
                selectedRowKeys: [formattedValue.account_id]
            });
            setCountry(formattedValue.country)
            const transformedItem = {
                ...value,
                created_at: formattedValue.created_at ? convertAndFormatDateTime(formattedValue.created_time ? `${formattedValue.created_at} ${formattedValue.created_time}` : formattedValue.created_at, companyProfile, profile) : "",
                modified_at: formattedValue.modified_at ? convertAndFormatDateTime(formattedValue.modified_time ? `${formattedValue.modified_at} ${formattedValue.modified_time}` : formattedValue.modified_at, companyProfile, profile) : "",
            };
            setDisplayData(transformedItem);
            const groupedData = customGroups
                .map(group => {
                    const groupId = group.customFieldGroupId;
                    const fields = (customFields?.[groupId] || [])
                        .filter(field =>
                            !excludedFields.includes(field.fieldKey) &&
                            !excludedType.includes(field.fieldType) &&
                            field.fieldVisible === 'Yes'
                        )
                        .map(field => {
                            let value;
                            if (field.customFieldType === "Custom") {
                                const cf = formatteddisplayValue?.customFieldValues?.find(
                                    c => c.fieldId === field.fieldId
                                );
                                value = cf?.value ?? null;
                            } else {
                                value = formatteddisplayValue[field.fieldKey];
                            }
                            return {
                                ...field,
                                value:
                                    field.fieldType === "Multi-Dropdown"
                                        ? value || []
                                        : normalizeValue(value) ?? null
                            };
                        });
                    return {
                        ...group,
                        fields
                    };
                });
            setArrayDisplayData(groupedData);
        }
    }
    async function deleteMenu(ids) {
        setAccountIDs([ids])
        setUpdatePopup(true)
        setPopupType("Delete")
    }
    async function getSharingPermissions(id) {
        if (id) {
            setDataPermissions(id)
        }
        else {
            setDataPermissions("Read,Update,Delete,Sharing")
        }
    }
    const CloseDrawer = () => {
        setCancelConfirmOpen(false)
        setApproveOpen(false)
        setApproveCondition(false)
        setAssignOwner(null)
        const allValues = form.getFieldsValue(true);
        const resetTitles = {};
        Object.keys(allValues).forEach(key => {
            if (key.startsWith("title-")) {
                resetTitles[key] = undefined;
            }
        });
        form.setFieldsValue(resetTitles);
        const formValues = allFieldStructure
            .filter(item => item.fieldType !== "MultiFileUpload" && item.fieldType !== "FileUpload")
            .reduce((acc, item) => {
                acc[item.fieldKey] =
                    item.fieldType === "Multi-Dropdown" ? [] :
                        item.fieldType === "CheckBox" ? false : null;
                return acc;
            }, {});
        form.setFieldsValue(formValues);
        setImages({});
        setDeleteOptions({});
        setFileLists({});
        setCompanyId()
        setStates({
            ...states,
            selectedRowKeys: []
        });
        setCountry()
        setState()
        setCity()
        if (FromPage !== "EntityUpdate" && ShortCut !== "Shortcut" && FromPage !== "FromContact") {
            GetAll();
            setCratePage();
        }
        if (ShortCut === "Shortcut" || FromPage === "FromContact") {
            setCratePage()
        }
        if (drawerPage === "CloneLead" || ShortCut === "Shortcut") {
            PageCancel()
        }
        setDrawerPage()
        setEdit(false);
        setEditField(false);
        dispatch(setEditCall(false))
        setAllFieldStructure([])
        prevValues.current = { UrlId: "", FromPage: "" };
        setUiReady(false);
    }
    const CloseDrawerNew = () => {
        setCancelConfirmOpen(false)
        setDrawerPage()
        setEdit(false);
        setEditField(false);
        dispatch(setEditCall(false))
        const allValues = form.getFieldsValue(true);
        const resetTitles = {};
        Object.keys(allValues).forEach(key => {
            if (key.startsWith("title-")) {
                resetTitles[key] = undefined;
            }
        });
        form.setFieldsValue(resetTitles);
    }
    async function getData(id) {
        try {
            if (drawerPage === "CloneLead") {
                const responseData = await FetchAccountDetails(id);
                const response = responseData.data
                getSharingPermissions(undefined)
                setData(response);
            } else {
                const responseDataRES = await FetchAccountDetails(id)
                if (!responseDataRES.allow) throw new Error();
                const response = responseDataRES.data
                getSharingPermissions(response?.sharingPermission?.sharePermission)
                setData(response);
            }
        } catch (error) {
            let secondsToGo = 3;
            const key = 'redirectCountdown';
            message.open({
                key,
                type: 'error',
                content: `This record is no longer available. It may have been deleted or moved`,
                duration: 0,
            });
            const interval = setInterval(() => {
                secondsToGo -= 1;
                if (secondsToGo === 0) {
                    clearInterval(interval);
                    message.destroy(key);
                    PageCancel();
                } else {
                    message.open({
                        key,
                        type: 'error',
                        content: `This record is no longer available. It may have been deleted or moved`,
                        duration: 0,
                    });
                }
            }, 1000);
        }
    }
    async function getData1(id, hideMessage, isAutomation, updateResponse) {
        try {
            const responseDataRES = await FetchAccountDetails(id)
            hideMessage();
            if (isAutomation) {
                successMessage("Automation rule triggered", updateResponse.data[0].message);
            } else {
                message.success(
                    <span>
                        Account <strong>{updateResponse?.data?.[0]?.entityName}</strong> has been updated successful
                    </span>
                );
            }
            if (!responseDataRES.allow) throw new Error();
            const response = responseDataRES.data
            getSharingPermissions(response?.sharingPermission?.sharePermission)
            setData(response);
            setTrigger("activity")
            loadingRef.current = false;
            setDoubleClick(false)
            CloseDrawerNew();
        } catch (error) {
            hideMessage();
            loadingRef.current = false;
            setDoubleClick(false)
            if (isAutomation) {
                successMessage("Automation rule triggered", updateResponse.data[0].message);
            } else {
                message.success(
                    <span>
                        Account <strong>{updateResponse?.data?.[0]?.entityName}</strong> has been updated successful
                    </span>
                );
            }
            let secondsToGo = 3;
            const key = 'redirectCountdown';
            message.open({
                key,
                type: 'error',
                content: `This record is no longer available. It may have been deleted or moved`,
                duration: 0,
            });
            const interval = setInterval(() => {
                secondsToGo -= 1;
                if (secondsToGo === 0) {
                    clearInterval(interval);
                    message.destroy(key);
                    PageCancel();
                } else {
                    message.open({
                        key,
                        type: 'error',
                        content: `This record is no longer available. It may have been deleted or moved`,
                        duration: 0,
                    });
                }
            }, 1000);
        }
    }
    const { NavigationDecrypted } = useNavigationDecrypted()
    async function getEntityAvalibitlity() {
        let dataFound = true;
        try {
            const response = await NavigationDecrypted(UrlId[1])
            if (response) {
                dataFound = true;
                setAccountId(response)
                getData(response)
                getList("Update")
            }
            else {
                dataFound = false;
            }
        } catch (error) {
            dataFound = false;
        }
        if (!dataFound) {
            let secondsToGo = 3;
            const key = 'redirectCountdown';
            message.open({
                key,
                type: 'error',
                content: `This record is no longer available. It may have been deleted or moved`,
                duration: 0,
            });
            const interval = setInterval(() => {
                secondsToGo -= 1;
                if (secondsToGo === 0) {
                    clearInterval(interval);
                    message.destroy(key);
                    PageCancel();
                } else {
                    message.open({
                        key,
                        type: 'error',
                        content: `This record is no longer available. It may have been deleted or moved`,
                        duration: 0,
                    });
                }
            }, 1000);
        }
    }
    const fetchDropdownOptions = async () => {
        // Collect all unique dropdownIds from all custom fields
        const allAttrs = Object.values(customFields || {}).flat();
        const dropdownIds = [...new Set(
            allAttrs
                .filter(attr => attr.dropdownId)
                .map(attr => attr.dropdownId)
        )];
        if (!dropdownIds.length) return;
        // Fetch all in parallel
        const results = await Promise.allSettled(
            dropdownIds.map(id => findAllCustomOptionsByDropdown(id))
        );
        const map = results.reduce((acc, result, index) => {
            const attr = allAttrs.find(a => a.dropdownId === dropdownIds[index]);
            if (result.status === 'fulfilled') {
                acc[dropdownIds[index]] = result.value
                    .sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0))
                    .map(item => ({
                        value: item.customDropdownOptionId,
                        label: item.option,
                    }));
            } else {
                acc[dropdownIds[index]] = [];
                message.error(`Failed to load "${attr?.dropdownType}" dropdown`);
            }
            return acc;
        }, {});
        setOptionsMap(map);
    };
    const handleNoteClick = (value) => {
        setNotePopup(true)
        setPopupType(value)
        setNaCTrigger("trigger")
        setPage("Entity")
    }
    const AssignToFucntion = () => {
        if (approveCondition) { setApproveOpen(true) }
        else {
            setAccountIDs([accountId])
            setUpdatePopup(true)
            setPopupType("Change Owner")
            setAction("SingleChangeOwner")
        }
    }
    const HandleShareClick = () => {
        setSharePopup(true)
    }
    const handleCountryChange = async (value, option) => {
        setCountry(value);
        if (option.key) {
            try {
                const response = await getStateData(option.key); setAllState(response); setState(); setCity(); setAllCity([]);
                form.setFieldsValue({ state: null, city: null })
            }
            catch (error) { message.error(error); }
        } else {
            setAllState([]); setAllCity([]); setState(); setCity(); form.setFieldsValue({
                state: null, city: null
            })
        }
    };
    const handleStateChange = async (value, option) => {
        setState(value);
        if (option.key) {
            try {
                const response = await getCityData(option.key); setAllCity(response); setCity(); form.setFieldsValue({
                    city: null
                })
            }
            catch (error) { message.error(error); }
        } else {
            setAllCity([]); setCity(); form.setFieldsValue({
                city: null
            })
        }
    };
    const handleCityChange = (value) => { setCity(value); };
    const closeMailComposr = () => {
        setMailOpen(false);
    };
    const urlPathname = window.location.pathname;
    const urlSearch = window.location.search;
    const combinedUrl = urlPathname + urlSearch;
    const CreateTask = (id) => {
        setCreatePageTask("ListingLead")
        setNaCTrigger("trigger")
        setTaskProp({
            type: "Account",
            ids: [id]
        })
    }
    const getAcountType = async () => {
        try {
            const statusDropdown = allFieldStructure.find((item) => item.fieldKey === "accountType")
            const data = await findAllCustomOptionsByDropdown(statusDropdown.dropdownId)
            const filteredData = data.find((item) => item.option === "Customer")
            form.setFieldsValue({
                accountType: filteredData?.customDropdownOptionId ?? null,
            })
        }
        catch (error) {
            message.error(error)
        }
    }
    const getIndustryData = async () => {
        try {
            const statusDropdown = allFieldStructure.find((item) => item.fieldKey === "industry")
            const data = await findAllCustomOptionsByDropdown(statusDropdown.dropdownId)
            const filteredData = data.find((item) => item.option === "Other")
            form.setFieldsValue({
                industry: filteredData?.customDropdownOptionId ?? null,
            })
        }
        catch (error) {
            message.error(error)
        }
    }
    const getCustomerStatus = async () => {
        try {
            const statusDropdown = allFieldStructure.find((item) => item.fieldKey === "customerStatus")
            const data = await findAllCustomOptionsByDropdown(statusDropdown.dropdownId)
            const filteredData = data.find((item) => item.option === "Prospective Customer")
            form.setFieldsValue({
                customerStatus: filteredData?.customDropdownOptionId ?? null,
            })
        }
        catch (error) {
            message.error(error)
        }
    }
    const CreateMail = async () => {
        if (emailactiontype) {
            setPopupMessage(true)
        }
        else {
            const contactData = await getContactData(accountId)
            if (contactData.length) {
                try {
                    const allEmails = contactData
                        .map(c => ({
                            id: c.contactsId,
                            type: "Contacts"
                        }));
                    // .map(c => c?.email)
                    // .filter(email => email);
                    setNaCTrigger("trigger")
                    setEmailAttendees(allEmails);
                    setMailOpen(true)
                } catch (error) {
                    message.error(error);
                }
            } else {
                message.info("No contacts found for this account")
            }
        }
    }
    const onAccountTypeChange = (value, option) => {
        setAccountTypeName(option.children)
        if (option.children !== "Customer") {
            form.setFieldsValue({
                customerStatus: null,
                accountOwner: null,
                parentaccount: null,
                rating: null,
                industry: null
            });
            if (option.children === "Competitor") {
                getIndustryData()
            }
        }
        else if (option.children === "Customer") {
            getCustomerStatus()
            form.setFieldsValue({
                industry: null
            });
        }
    }
    const getUserDetail = async () => {
        if (UrlId === undefined || UrlId === null) {
            if (profile.department === "Sales") {
                form.setFieldsValue({
                    accountOwner: profile.userId
                });
            }
            setCompanyId(profile.companyId)
        }
    }
    const fetchAll = async () => {
        await Promise.allSettled([
            AccountApi(),
            getCountry(),
            UserDetailsApi(),
        ])
    };
    const fetchAll1 = async () => {
        await Promise.allSettled([
            fetchDropdownOptions(),
        ]);
        setTimeout(() => {
            setUiReady(true);
        }, 1000);
    };
    useEffect(() => {
        if (FromPage) {
            scroolup();
            fetchCustomGroupsAndFields()
        }
    }, [FromPage]);
    useEffect(() => {
        if (FromPage && displayData && customFields) {
            fetchAll1();
        }
    }, [FromPage, displayData, customFields]);
    useEffect(() => {
        if (FromPage && editField && displayData) {
            fetchAll();
        }
    }, [FromPage, editField, displayData]);
    const fetchAlld = async () => {
        await Promise.allSettled([
            getEntityAvalibitlity(),
        ])
    };
    const fetchAllsetData = async () => {
        await Promise.allSettled([
            getAcountType(),
            getCustomerStatus(),
        ])
    };
    useEffect(() => {
        if (allFieldStructure.length) {
            const currentUrlId = JSON.stringify(UrlId); // <-- serialize for comparison
            const currentFromPage = FromPage;
            if (prevValues.current.UrlId === currentUrlId && prevValues.current.FromPage === currentFromPage) return;
            prevValues.current = { UrlId: currentUrlId, FromPage: currentFromPage };
            if (FromPage) {
                if (FromPage === "EntityUpdate") {
                    fetchAlld()
                }
                else {
                    const formValues = allFieldStructure
                        .filter(item => item.fieldType !== "MultiFileUpload" && item.fieldType !== "FileUpload")
                        .reduce((acc, item) => {
                            acc[item.fieldKey] =
                                item.fieldType === "Multi-Dropdown" ? [] :
                                    item.fieldType === "CheckBox" ? false : undefined;
                            return acc;
                        }, {});
                    form.setFieldsValue(formValues);
                    setImages({});
                    setDeleteOptions({});
                    setFileLists({});
                    setDisplayData("Create")
                    setAccountId()
                    setStates({ ...states, selectedRowKeys: [] });
                    setCountry()
                    setState()
                    setCity()
                    getUserDetail()
                    getList("Create")
                    setDataPermissions("Read,Update,Delete,Sharing")
                    fetchAllsetData()
                    setAccountTypeName("Customer")
                    setEdit(true)
                    setEditField(true)
                }
            }
        }
    }, [UrlId, FromPage, allFieldStructure]);
    useEffect(() => {
        if (drawerPage === "CloneLead") {
            getData(accountId)
            setDataPermissions("Read,Update,Delete,Sharing")
            setEditField(true)
            setEdit(true)
            getList("Create")
        }
    }, [drawerPage]);
    const { ExcryptedNavigation } = useExcryptedNavigation();
    const ViewDetailPage = (id, entity) => {
        ExcryptedNavigation("Nav", id, entity, history, null, null, null)
    }
    const OwnerChecking = async (value) => {
        if (value && value !== displayData?.accountOwner) {
            try {
                const Response = await getOwnerChange(displayData?.accountOwner, accountId)
                if (Response === "") {
                    setOpenOwnerPopup(false)
                }
                else {
                    setOpenOwnerPopup(true)
                    setOpenOwnerContent(Response)
                }
            }
            catch (error) {
                message.error(error)
            }
        }
    }
    const handleOpenOwnerPopup = () => {
        setOpenOwnerPopup(false)
        form.setFieldsValue({
            accountOwner: displayData?.accountOwner
        })
    }
    const handleEditChange = () => {
        if (approveCondition) {
            setApproveOpen(true)
        }
        else {
            setEditField(true)
            setEdit(true)
            dispatch(setEditCall(true))
            setTrigger("");
            setApproveOpen(false)
        }
    }
    const createDeal = (Aid) => {
        setNaCTrigger("trigger")
        setCratePages("AccountPage")
        setDataForDeal({ AccountId: Aid })
    }
    const CloneLead = () => {
        setDrawerPage("CloneLead")
    }
    const handleMergeclick = () => {
        if (approveCondition) {
            setApproveOpen(true)
            setMergeOpen(false)
        }
        else {
            setNaCTrigger("trigger")
            setApproveOpen(false)
            setMergeOpen(true)
        }
    }
    const openTacking = () => {
        setOpenIntelligence(!openIntelligence)
    }
    const moreAction = accountTypeName === "Customer" ? "Yes" : "No"
    const MoreAction = ({ closeDropdown }) => (accountTypeName === "Customer" ?
        <div style={{
            padding: "0px 10px",
            width: "100%",
            height: "100%",
        }}>
            <Link to={combinedUrl} onClick={!edit && canUpdateDelete(permissions, dataPermissions, "Update", 2011) ? () => { AssignToFucntion(); closeDropdown() } : undefined} className={`text_icon ${(canUpdateDelete(permissions, dataPermissions, "Update", 2011)) ? "" : 'disabled_link'}`}>
                <ChangeOwnerIcon height={15} width={15} marginRight={5} /> Change Owner
            </Link>
            <Link to={combinedUrl} onClick={(edit || !canCreate(permissions, 2010)) ? undefined : () => { handleNoteClick("Create"); closeDropdown() }} className={`text_icon ${(edit || !canCreate(permissions, 2010)) ? "disabled_link" : ''}`}>
                <NotesIcon height={15} width={15} marginRight={5} /> Add a Note
            </Link>
            <Link to={combinedUrl} onClick={(!edit && canUpdateDelete(permissions, dataPermissions, "Update", 2011)) ? () => { handleMergeclick(); closeDropdown() } : undefined} className={`text_icon ${(!edit && canUpdateDelete(permissions, dataPermissions, "Update", 2011)) ? "" : 'disabled_link'}`}>
                <MergeIcon height={15} width={15} marginRight={5} /> Merge Duplicates
            </Link>
            <Link to={combinedUrl} onClick={(!edit && report?.allow) ? () => { openTacking(); closeDropdown() } : undefined} className={`text_icon ${(!edit && report?.allow) ? "" : 'disabled_link'}`}>
                <ReportsIcon height={15} width={15} marginRight={5} /> Intelligence Report
            </Link>
        </div > : <></>
    );
    MoreAction.propTypes = {
        closeDropdown: PropTypes.func.isRequired,
    };
    const ButtonActions = [
        {
            Actions: <div className={(!canCreate(permissions, 2010)) ? "disabled-style" : 'Hover-Refresh2 back-hover1 able-style'}
                role="button"
                tabIndex={0} title='Send Email'
                onClick={(!canCreate(permissions, 2010)) ? undefined : () => CreateMail()}
                onKeyDown={(event) => {
                    if (canCreate(permissions, 2010) && (event.key === 'Enter' || event.key === ' ')) {
                        CreateMail()
                    }
                }}
                aria-label='mail'
            > <EmailIcon height={20} width={20} /></div>
        },
        {
            Actions: <div className={(!canCreate(permissions, 2010)) ? "disabled-style" : 'Hover-Refresh2 back-hover1 able-style'}
                role="button"
                tabIndex={0} title='Create Task'
                onClick={(!canCreate(permissions, 2010)) ? undefined : () => CreateTask(accountId)}
                onKeyDown={(event) => {
                    if (canCreate(permissions, 2010) && (event.key === 'Enter' || event.key === ' ')) {
                        CreateTask(accountId)
                    }
                }}
                aria-label='task'
            > <TaskIcon height={20} width={20} /></div>
        },
        {
            Actions: <div className={(!canCreate(permissions, 2010)) ? "disabled-style" : 'Hover-Refresh2 back-hover1 able-style'}
                role="button"
                tabIndex={0} title='Clone'
                onClick={(!canCreate(permissions, 2010)) ? undefined : () => CloneLead()}
                onKeyDown={(event) => {
                    if (canCreate(permissions, 2010) && (event.key === 'Enter' || event.key === ' ')) {
                        CloneLead()
                    }
                }}
                aria-label='clone'
            > <CloneIcon height={20} width={20} /></div>
        },
        {
            Actions:
                <div className={(edit || displayData?.accountOwner !== profile.userId) ? "disabled-style" : 'Hover-Refresh2 back-hover1 able-style'}
                    role="button"
                    tabIndex={0} title='Share'
                    onClick={(edit || displayData?.accountOwner !== profile.userId) ? undefined : () => HandleShareClick()}
                    onKeyDown={(event) => {
                        if ((displayData?.accountOwner === profile.userId) && (event.key === 'Enter' || event.key === ' ')) {
                            HandleShareClick()
                        }
                    }}
                    aria-label='share'
                > <ShareIcon height={20} width={20} /></div>
            // <div className={(edit || !canShare(dataPermissions, "Sharing")) ? "disabled-style" : 'Hover-Refresh2 back-hover1 able-style'}
            //     role="button"
            //     tabIndex={0} title='Share'
            //     onClick={(edit || !canShare(dataPermissions, "Sharing")) ? undefined : () => HandleShareClick()}
            //     onKeyDown={(event) => {
            //         if (canShare(dataPermissions, "Sharing") && (event.key === 'Enter' || event.key === ' ')) {
            //             HandleShareClick()
            //         }
            //     }}
            //     aria-label='share'
            // > <ShareIcon height={20} width={20} /></div>
        },
    ]
    let FinalActions = [...ButtonActions];
    if (accountTypeName !== "Customer") {
        FinalActions = FinalActions.slice(2, -1);
        FinalActions.push({
            Actions: <div className={(!canCreate(permissions, 2010)) ? "disabled-style" : 'Hover-Refresh2 back-hover1 able-style'}
                role="button"
                tabIndex={0} title='Add a Note'
                onClick={(!canCreate(permissions, 2010)) ? undefined : () => handleNoteClick("Create")}
                onKeyDown={(event) => {
                    if (canCreate(permissions, 2010) && (event.key === 'Enter' || event.key === ' ')) {
                        handleNoteClick("Create")
                    }
                }}
                aria-label='notes'
            > <NotesIcon height={20} width={20} /></div>
        }, {
            Actions: <div className={(!canUpdateDelete(permissions, dataPermissions, "Update", 2011)) ? "disabled-style" : 'Hover-Refresh2 back-hover1 able-style'}
                role="button"
                tabIndex={0} title='Merge Duplicates'
                onClick={(!canUpdateDelete(permissions, dataPermissions, "Update", 2011)) ? undefined : () => handleMergeclick()}
                onKeyDown={(event) => {
                    if (canUpdateDelete(permissions, dataPermissions, "Update", 2011) && (event.key === 'Enter' || event.key === ' ')) {
                        handleMergeclick()
                    }
                }}
                aria-label='merge'
            > <MergeIcon height={20} width={20} /></div>
        }, {
            Actions: <div className={(!report?.allow) ? "disabled-style" : 'Hover-Refresh2 back-hover1 able-style'}
                role="button"
                tabIndex={0} title='Intelligence Report'
                onClick={(!report?.allow) ? undefined : () => handleMergeclick()}
                onKeyDown={(event) => {
                    if (report?.allow && (event.key === 'Enter' || event.key === ' ')) {
                        handleMergeclick()
                    }
                }}
                aria-label='intelligence'
            > <ReportsIcon height={20} width={20} /></div>
        });
    }
    const LeadInfos = {
        profile: images.accountProfile ?? null,
        Classname: "AccountIcon",
        letterIcon: displayData?.accountName,
        name: `${displayData?.accountName}`,
        subName: displayData?.accountNumber && displayData?.accountNumber !== "" ? displayData?.accountNumber : "Account Number",
        mainAction: accountTypeName === "Customer" ? <>
            <Button className="button_colors" size="small" style={{ width: "60%" }} onClick={() => createDeal(displayData?.account_id)} disabled={!canCreate(permissions, 2014)}>
                <DealIcon height={25} width={25} /> Create Deal
            </Button>
        </> : undefined,
    }
    const isEqual = (a, b) => {
        if (a === b) return true;
        // if (typeof a !== typeof b) return false;
        if (
            (typeof a === "number" && typeof b === "string") ||
            (typeof a === "string" && typeof b === "number")
        ) {
            return String(a) === String(b);
        }
        if (Array.isArray(a) && Array.isArray(b)) {
            if (a.length !== b.length) return false;
            return a.every((item, i) => isEqual(item, b[i]));
        }
        if (typeof a === "object" && a !== null && b !== null) {
            const keysA = Object.keys(a);
            const keysB = Object.keys(b);
            if (keysA.length !== keysB.length) return false;
            return keysA.every(key => isEqual(a[key], b[key]));
        }
        return false;
    };
    const getChangedFields = (currentStructure, initialStructure) => {
        return currentStructure.filter((currField) => {
            const initField = initialStructure.find((f) => f.fieldId === currField.fieldId);
            if (!initField) return true;
            const currValue = currField.value;
            const initValue = initField.value;
            return !isEqual(currValue, initValue);
        });
    };
    const EditOpenForDrawer = () => {
        setEdit(true)
        dispatch(setEditCall(true))
    }
    const onSubmit = async (values) => {
        if (loadingRef.current) return;
        loadingRef.current = true;
        setDoubleClick(true);
        let hideMessage;
        const currentStructure = await Promise.all(
            allFieldStructure.map(async (field) => {
                let value;
                switch (field.fieldType) {
                    case 'FileUpload':
                        value = normalizeValue(images[field.fieldKey] ?? null);
                        break;
                    case 'MultiFileUpload':
                        value = fileLists[field.fieldKey] || [];
                        break;
                    case 'Date':
                        value = values[field.fieldKey]
                            ? moment(values[field.fieldKey]).format("YYYY-MM-DD")
                            : null;
                        break;
                    case 'Number':
                        // string → number or null
                        value = values[field.fieldKey] !== undefined && values[field.fieldKey] !== "" && values[field.fieldKey] !== null
                            ? Number(values[field.fieldKey])
                            : null;
                        break;
                    case 'Percentage':
                        // string → number or null
                        value = values[field.fieldKey] !== undefined && values[field.fieldKey] !== "" && values[field.fieldKey] !== null
                            ? Number(values[field.fieldKey])
                            : null;
                        break;
                    case 'Currency':
                        value = values[field.fieldKey] !== undefined && values[field.fieldKey] !== "" && values[field.fieldKey] !== null
                            ? await convertCurrency(ConvertRate, Number(values[field.fieldKey]))
                            : null;
                        break;
                    case 'Multi-Dropdown':
                        value = values[field.fieldKey] && values[field.fieldKey].length > 0
                            ? values[field.fieldKey].join(",")
                            : null;
                        break;
                    case 'CheckBox':
                        value = values[field.fieldKey] ?? false;
                        break;
                    default:
                        value = normalizeValue(values[field.fieldKey] ?? null);
                        break;
                }
                return { ...field, value };
            })
        );
        const changedFields = getChangedFields(currentStructure, allFieldStructure);
        if (changedFields.length === 0) {
            getData(accountId); scroolup(); message.success("Account updated");
            loadingRef.current = false; setDoubleClick(false); CloseDrawerNew();
            return;
        }
        const defaultChanges = {};
        const customFieldValues = [];
        changedFields.forEach((field) => {
            if (field.customFieldType === "Default") {
                defaultChanges[field.fieldKey] = field.value;
            } else {
                const obj = {
                    entityId: field.entityId,
                    fieldId: field.fieldId,
                    value: field.value,
                };
                customFieldValues.push(obj);
            }
        });
        const payload = {
            qualified: normalizeValue("Qualified"),
            companyId: normalizeValue(companyId),
            ...defaultChanges,
            ...(customFieldValues.length > 0 && { customFieldValues }),
        };
        try {
            hideMessage = message.loading("Loading...", 0);
            if (FromPage === "EntityUpdate" && drawerPage !== "CloneLead") {
                const response = await updateAccounts(payload, accountId)
                if (response.status === 200) {
                    if (Array.isArray(response.data) && response.data.length > 0 && response.data[0].entityType !== 'Success') {
                        setErrorData(response.data);
                        setIsModalVisible1(true);
                        loadingRef.current = false;
                        setDoubleClick(false)
                        hideMessage();
                    }
                    else {
                        const isAutomation = response.data[0].message === AutomationMessage;
                        const isApproval = response.data[0].message === ApprovalMessage;
                        const ownerChanged = displayData?.accountOwner !== values.accountOwner;
                        if (isApproval) {
                            hideMessage();
                            getData(accountId)
                            scroolup()
                            successMessage("Your action has triggered an approval process", "This record is now in the approval queue, and further changes are restricted until the approval process is complete", "Approve");
                            loadingRef.current = false;
                            setDoubleClick(false)
                            CloseDrawerNew()
                        }
                        else if (ownerChanged) {
                            hideMessage();
                            if (isAutomation) {
                                successMessage("Automation rule triggered", response.data[0].message);
                            } else {
                                message.success(
                                    <span>
                                        Account <strong>{response?.data?.[0]?.entityName}</strong> has been updated successful
                                    </span>
                                );
                            }
                            dispatch(setEditCall(false));
                            history.push('/Home/accounts');
                        }
                        else {
                            getData1(accountId, hideMessage, isAutomation, response)
                            scroolup()
                        }
                    }
                }
            }
            else {
                const response = await createAccounts(payload)
                if (response.status === 201) {
                    AccountApiCall()
                    if (response.data?.accountsId) {
                        Callback(response.data?.accountsId)
                    }
                    const isAutomation = response?.data?.message === AutomationMessage;
                    const isApproval = response?.data?.message === ApprovalMessage;
                    hideMessage();
                    if (isApproval) {
                        successMessage("Your action has triggered an approval process", "This record is now in the approval queue, and further changes are restricted until the approval process is complete", "Approve");
                    } else if (isAutomation) {
                        successMessage("Automation rule triggered", response?.data?.message);
                    } else {
                        message.success(response?.data?.message);
                    }
                    loadingRef.current = false;
                    setDoubleClick(false)
                    CloseDrawer();
                }
            }
        }
        catch (error) {
            loadingRef.current = false;
            setDoubleClick(false)
            hideMessage();
            message.error(error)
        }
    }
    const CloseDrawer2 = () => {
        scroolup();
        getData(accountId)
        setEditField(false)
        setEdit(false);
        dispatch(setEditCall(false))
        setDrawerPage()
        const allValues = form.getFieldsValue(true);
        const resetTitles = {};
        Object.keys(allValues).forEach(key => {
            if (key.startsWith("title-")) {
                resetTitles[key] = undefined;
            }
        });
        form.setFieldsValue(resetTitles);
    }
    const PageCancel1 = () => {
        if (FromPage === "EntityUpdate" && drawerPage !== "CloneLead") {
            CloseDrawer2()
        }
        else if (FromPage === "EntityUpdate" && drawerPage === "CloneLead") {
            setCancelConfirmOpen(true)
        }
        else {
            setCancelConfirmOpen(true)
        }
    }
    const getRefreshtheTable = () => {
        CloseDrawer2()
        setTrigger("activity")
    }
    const memoUrlId = useMemo(() => (UrlId ? [UrlId[0], accountId] : null), [UrlId, accountId]);
    const updatePsqq = useMemo(() => ({ permission: permissions, dataPermission: dataPermissions, type: "Update", PId: 2011 }), [permissions, dataPermissions]);
    const getDetailsDatas = useCallback(() => getData(accountId), [accountId]);
    const MemoLeadFields = useMemo(() => (
        <AccountFields displayData={displayData} setNaCTrigger={setNaCTrigger} arrayDisplayData={arrayDisplayData} />
    ), [arrayDisplayData, setNaCTrigger, displayData]);
    const MemoRelatedTab = useMemo(() => (
        <RelatedTab EntityType={accountTypeName === "Customer" ? "Account" : "Account1"} UrlId={memoUrlId} NacTrigger={NacTrigger} setNaCTrigger={setNaCTrigger} profile={profile} emailactiontype={emailapiValues} disabledData={!canCreate(permissions, 2014)} displayData={displayData} disabledData2={!canCreate(permissions, 2006)} trigger={trigger} ownerId={displayData?.accountOwner} />
    ), [memoUrlId, NacTrigger, setNaCTrigger, profile, emailapiValues, trigger, displayData]);
    const MemoRightRelatedData = useMemo(() => (
        <AccountRightData displayData={displayData} dataDisables={dataDisables} profile={profile} ViewDetailPage={ViewDetailPage} Role={Role} UrlId={memoUrlId} NacTrigger={NacTrigger} setNaCTrigger={setNaCTrigger} conditionApply={accountTypeName} trigger={trigger} />
    ), [displayData, dataDisables, profile, ViewDetailPage, Role, memoUrlId, NacTrigger, setNaCTrigger, trigger]);
    const leadSharedProps = useMemo(() => ({
        form, edit, combinedUrl, UrlId, displayData,
        dataDisables, setDataDisables,
        allCountry, country, handleCountryChange,
        allState, state, handleStateChange,
        allCity, city, handleCityChange,
        images, setImage, users, OwnerChecking,
        deleteOptions, setDeleteOption,
        validateCode, onAccountTypeChange,
        fileLists, setFileList, accountData,
    }), [
        form, edit, combinedUrl, UrlId, displayData, users, dataDisables, accountData,
        allCountry, country, allState, state, allCity, city,
        validateCode, onAccountTypeChange,
        images, deleteOptions, fileLists, permissions, canCreate, OwnerChecking,
    ]);
    return (
        <>
            {FromPage === "EntityUpdate" ?
                <Main>
                    {displayData ? <>
                        {FromPage === "EntityUpdate" &&
                            <DetailsPage PageCancel={PageCancel} handleEditChange={handleEditChange} canUpdateDelete={canUpdateDelete}
                                UpdatePs={updatePsqq} moreAction={moreAction}
                                DetailsPageMoreAction={<MoreAction />} ButtonActions={FinalActions} Maincontent={LeadInfos} UpdateDataPage={undefined}
                                EntityTabDetails={MemoLeadFields} EntityRelatedTab={MemoRelatedTab} RightRelatedDetails={MemoRightRelatedData}
                            />}
                    </>
                        :
                        <div className="spin">
                            <Spin />
                        </div>}
                </Main> : <></>}
            <Drawer
                className='Drawer-Header-Pages'
                bodyStyle={{ padding: 0 }}
                title={
                    FromPage === "EntityUpdate" ?
                        drawerPage === "CloneLead" ? "Clone Account" :
                            <span>
                                Update Account
                                {displayData?.accountName && (
                                    <>
                                        <span style={{
                                            margin: '0 10px',
                                            color: '#d9d9d9',
                                            fontWeight: 'normal'
                                        }}>|</span>
                                        <span style={{ fontWeight: 'normal' }}>
                                            {displayData?.accountName}
                                        </span>
                                    </>
                                )}
                            </span>
                        : "Create Account"
                }
                closable={false}
                placement="right"
                open={editField}
                width="80%"
                extra={
                    <Space>
                        {!edit ?
                            <div className='Hover-Refresh2 back-hover1 able-style'
                                role="button"
                                tabIndex={0} title='Edit'
                                onClick={() => EditOpenForDrawer()}
                                onKeyDown={(event) => {
                                    if (event.key === 'Enter' || event.key === ' ') {
                                        EditOpenForDrawer()
                                    }
                                }}
                                aria-label='edit'
                            > <EditIcon height={20} width={20} /></div> : <></>}
                        <div className='Hover-Refresh2 back-hover1 able-style'
                            role="button"
                            tabIndex={0} title='Close'
                            onClick={() => PageCancel1()}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter' || event.key === ' ') {
                                    PageCancel1()
                                }
                            }}
                            aria-label='Close'
                        > <CancelIcon width={24} height={24} /></div>
                    </Space>
                }
                footer={
                    (edit && uiReady) ? [
                        <div className="form_action_button">
                            <Button
                                className="gray-button" size="small"
                                onClick={() => PageCancel1()}
                            >
                                <CancelIcon height={25} width={25} />Cancel
                            </Button>
                            {(FromPage === "EntityUpdate" && drawerPage !== "CloneLead") ?
                                <Button disabled={!canUpdateDelete(permissions, dataPermissions, "Delete", 2012) || deleteClick || doubleClick} loading={deleteClick}
                                    className="red-button" size="small"
                                    onClick={() => deleteMenu(accountId)}
                                >
                                    {!deleteClick && <DeleteIcon height={25} width={25} />}Delete
                                </Button> : <></>}
                            <Button size="small" htmlType="submit" className="button_colors" onClick={() => form.submit()} disabled={deleteClick || doubleClick} loading={doubleClick}>
                                {!doubleClick && <SaveIcon height={25} width={25} />}{FromPage === "EntityUpdate" && drawerPage !== "CloneLead" ? "Update" : "Save"}
                            </Button>
                        </div>] : false
                }>
                {(displayData && uiReady) ?
                    <Scrollbars autoHide autoHideTimeout={500} autoHideDuration={200}>
                        <AddUser>
                            <div className="user-info-form">
                                <Form style={{ width: '100%' }} form={form} name="info" onFinish={onSubmit} onFinishFailed={onFinishFailed} colon={false}>
                                    <BasicFormWrapper>
                                        <VerticalFormStyleWrap>
                                            <div className="add-product-block">
                                                <div style={{ margin: 40 }}>
                                                    <Row gutter={15}>
                                                        <Col xs={24}>
                                                            <div className="add-product-content">
                                                                <CommonFormFields
                                                                    groups={customGroups}
                                                                    customFields={customFields || {}}
                                                                    specialFields={LEAD_SPECIAL_FIELDS}
                                                                    sharedProps={leadSharedProps}
                                                                    optionsMap={optionsMap}
                                                                    combinedUrl={combinedUrl}
                                                                    moduleIcon="AccountIcon"
                                                                    moduleLetter={displayData?.accountName?.slice(0, 1)?.toUpperCase() || 'A'}
                                                                />
                                                                {(UrlId !== undefined && UrlId !== null && UrlId[0] === "?ACCOUNT" && drawerPage !== "CloneLead") && <>
                                                                    <Heading as="h5">Other Information</Heading>
                                                                    <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                                        <Col span={8} style={{ marginBottom: 20 }}>
                                                                            <Form.Item label="Created Date" >
                                                                                <span >{displayData?.created_at}</span>
                                                                            </Form.Item>
                                                                        </Col>
                                                                        <Col span={8} style={{ marginBottom: 20 }}>
                                                                            <Form.Item label="Created By" >
                                                                                <UploadUserTag record={{
                                                                                    uploadedBy: `${displayData?.createdByFirstName} ${displayData?.createdByLastName}`,
                                                                                    uploadedById: displayData?.created_by,
                                                                                    uploadedProfile: displayData?.createdByProfilePic
                                                                                }} />
                                                                            </Form.Item>
                                                                        </Col>
                                                                        <Col span={8} style={{ marginBottom: 20 }}>
                                                                            <Form.Item label="Modified Date" >
                                                                                <span >{displayData?.modified_at}</span>
                                                                            </Form.Item>
                                                                        </Col>
                                                                        <Col span={8} style={{ marginBottom: 20 }}>
                                                                            <Form.Item label="Modified By" >
                                                                                <UploadUserTag record={{
                                                                                    uploadedBy: `${displayData?.modifiedByFirstName} ${displayData?.modifiedByLastName}`,
                                                                                    uploadedById: displayData?.modified_by,
                                                                                    uploadedProfile: displayData?.modifiedByProfilePic
                                                                                }} />
                                                                            </Form.Item>
                                                                        </Col>
                                                                    </Row >
                                                                </>}
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </div>
                                        </VerticalFormStyleWrap>
                                    </BasicFormWrapper>
                                </Form>
                            </div>
                        </AddUser>
                    </Scrollbars> :
                    <div className="spin">
                        <Spin />
                    </div>}
            </Drawer >
            {isModalVisible1 && <UpdateConnectionPopup confirmPopup={isModalVisible1} setConfirmPopup={setIsModalVisible1} Respone={errorData} page="Details" type="Account" getCallBack={getRefreshtheTable} />}
            {cancelConfirmOpen && <AllCancelPopup confirmPopup={cancelConfirmOpen} setConfirmPopup={setCancelConfirmOpen} GetCallback={CloseDrawer} />}
            <AddTaskPage UrlId={undefined} FromPage={createPageTask} setCratePage={setCreatePageTask} CallBackTrigger={setNaCTrigger} fromPageforTask="FromDetails" taskProp={taskProp} />
            <AddDealPage UrlId={undefined} FromPage={createPages} setCratePage={setCratePages} dataForDeal={dataForDeal} CallBackTrigger={setNaCTrigger} />
            <ComposeMail mailOpen={mailOpen} close={closeMailComposr} entityName="Accounts" entity="EntityPages" toId={emailAttendees} AccountId={accountId} CallBackTrigger={setNaCTrigger} />
            {approveOpen && <Approvaldialog confirmPopup={approveOpen} setConfirmPopup={setApproveOpen} />}
            {sharePopup && <SharePopup sharePopup={sharePopup} setSharePopup={setSharePopup} sharingType="Account" sharingIds={[accountId]} PageTypes="Single" />}
            {updatePopup && <Popup updatePopup={updatePopup} setUpdatePopup={setUpdatePopup} accountIDs={accountIDs} popupType={popupType} action={action} assignOwner={assignOwner} GetAll={getDetailsDatas} successMessage={successMessage} setDoubleClick={setDelteClick} loadingRef={loadingRef} deleteClick={deleteClick} />}
            {notePopup && <NotesPopup setNotePopup={setNotePopup} notePopup={notePopup} popupType={popupType} UrlId={memoUrlId} setNaCTrigger={setNaCTrigger} page={page} />}
            {popupMessage && <DefaultMessagePopup messagePopup={popupMessage} setMessagePopup={setPopupMessage} pageType={pages} onNavigate={onnavigate} />}
            <MergePage meetingOpen={mergeOpen} deletecheck={!hasRoleDeletePermission(permissions, 2012)} setMeetingOpen={setMergeOpen} GetAll={getDetailsDatas} pageIdentifier="Accounts" setNaCTrigger={setNaCTrigger} PryData={displayData} />
            {
                openOwnerPopup && <Modal
                    title="Update account owner?"
                    open={openOwnerPopup}
                    onCancel={handleOpenOwnerPopup}
                    footer={[<div className="form_action_button">
                        <Button size="small" onClick={handleOpenOwnerPopup} className="button_colors">
                            <FeatherIcon icon="check" /> Ok
                        </Button>
                    </div>]}
                    maskClosable={false}
                > {openOwnerContent}
                </Modal>
            }
            <AccountIntePage openIntelligence={openIntelligence} openTacking={openTacking} researchContent={report?.data} />
        </>
    );
}

AddNew.propTypes = {
    UrlId: PropTypes.array.isRequired,
    FromPage: PropTypes.string.isRequired,
    setCratePage: PropTypes.func.isRequired,
    GetAll: PropTypes.func.isRequired,
    ShortCut: PropTypes.string.isRequired,
    AccountApiCall: PropTypes.func.isRequired,
    Callback: PropTypes.func.isRequired,
};
export default AddNew;
